import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Time(props) {
  const socket = useContext(SocketContext);

  const symbol_id = props.symbol_id;

  const [time, setTime] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);
    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, [socket, symbol_id]);

  const date = time ? time.split(" ")[0] : "";
  const clock = time ? time.split(" ")[1] : "";

  const trade = (data) => {
    if (data != null) {
      setTime(data.Timestamp);
    }
  };

  return (
    <div className="menuBuyPrice flex flex-col items-center justify-center">
      <div className="extraSmall">{date}</div>
      <div className="small">{clock}</div>
    </div>
  );
}
